import { useState } from 'react'
import {
  Button,
  Divider,
  Grid,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material'

import { CircleDownIcon, CircleUpIcon } from 'src/assets/icons'
import { GridItemCollapse } from './item-collapse.component'
import { ITranslationWithDefault } from 'src/types'

import { useStyles } from './styles'
import { useStyles as useStyles2 } from '../translations-table/styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  handleUpdate: () => void
  item: ITranslationWithDefault
}

const TranslationItem = ({ item, handleUpdate }: IProps) => {
  const [toggle, setToggle] = useState(false)
  const classes = useStyles()
  const classes2 = useStyles2()

  const handleCollapge = (e: any) => {
    e.stopPropagation()
    setToggle((toggle) => !toggle)
  }

  return (
    <>
      <ListItemButton onClick={handleCollapge} disableGutters className={classes.listItemButton}>
        <ListItemIcon>{toggle ? <CircleUpIcon /> : <CircleDownIcon />}</ListItemIcon>
        <ListItemText className={classes.collapseItem} disableTypography>
          <Grid container justifyContent="center">
            <Grid item xs={8}>
              <Typography
                className={`${classes.itemText} ${classes.itemPropertyText} ${
                  item.review_required
                    ? classes2.translationReview
                    : !item.value
                    ? classes2.translationMissing
                    : ''
                }`}
              >
                {item.namespace}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Button variant="contained" onClick={handleUpdate} size="small">
                <HelperWrapper t="update-button-text" />
              </Button>
            </Grid>
          </Grid>
        </ListItemText>
      </ListItemButton>
      <GridItemCollapse item={item} open={toggle} />
      <Divider />
    </>
  )
}

export { TranslationItem }
